// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @15.06.2017 16:59:22
import { EventText1_abstract } from './../abstract/SagaSchema/EventText1_abstract';
export class EventText1 extends EventText1_abstract {}
